import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesTicketsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesTicketsPages;
